function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

jQuery(document).ready(function($) {
  var imagesC = $("img:visible").length;
  var loadedImages = 0;
  $('body').imagesLoaded( { background: true })
    .always( function( instance ) {
      $("body").addClass("loaded")
    })
    .progress( function( instance, image ) {
      loadedImages++;
      var percentage = parseInt(loadedImages/imagesC*100) <= 100 ? parseInt(loadedImages/imagesC*100) : 100;
      $(".section-loading .h1").text(percentage+"%")
    });

  $.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height()/1.5;

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

  };
  var animatedItems = $('.products-list article, .blog-list article, .entry > *, .facts .item, .featured-items .item, .full-image, .option, .section-intro.home > .container, .related-list section article, .shop-image-holder, .prod-meta .meta-item, .sec-title');

  animatedItems.addClass("opacity-0");

  function animItems() {
    animatedItems.each(function() {
      var cur = $(this);
      if (cur.isOnScreen()) {
        if (!cur.hasClass("animated")) {
          cur.addClass("animated fadeInUp");
          window.setTimeout(function() {
            cur.removeClass("fadeInUp opacity-0");
          }, 850);
        };
      };
    });
  }
  animItems();
  $(document).on('click', ".menu >li > .trigger", function () {
    $("body").toggleClass("navstep-2");
    $(this).parent().toggleClass("active");
    return false;
  });
  $(document).on('click', ".menu >li li .trigger", function () {
    $(this).parent().toggleClass("active");
    return false;
  });
  $(document).on('click', ".nav .back", function () {
    $("body").removeClass("navstep-2");
    $(".menu .active").removeClass("active");
    return false;
  });
  $(document).on('click', ".menu-trigger, .nav .close", function () {
    $("body").toggleClass("active-menu");
    $(".nav .back").click()
    return false;
  });

  function updatePrice() {
    $(".total-row .right").text(Number.parseFloat($(".form-group .qnt-select input").val() * parseInt($(".selected-list .item[data-price]").attr("data-price"))).toFixed(2)+"€");
  }

  $(document).on('click', ".option .trigger", function () {
    $(this).parent().toggleClass("active");
    return false;
  });
  $(document).on('change', ".form-group .qnt-select input", function () {
    if ($(this).val() < 2) {
      $(this).val(2);
    }
    updatePrice();
  });
  $(document).on('click', ".option .btn-outline", function () {
    $(".second-step").addClass("active");
    $(".option-details .option").html($(this).parentsUntil(".option").parent().html())
    $('html, body').stop().animate({
      scrollTop: $(".selected-list").offset().top
    }, 600);
    updatePrice();
    $('input[name=event_id]').val($(this).attr("data-event"));
    return false;
  });

  function increment(curr) {
    curr.trigger("click2");
  }

  function decrement (curr) {
    curr.trigger("click2");
  }
  var timeoutId;
  var timeoutId2;
  var isHeldDown = false;
  $(document).on('mousedown', ".qnt-select .btn-plus", function () {
    isHeldDown = true;
    var cur = $(this);

    clearTimeout(timeoutId);
    clearTimeout(timeoutId2);
    (function loop () {
      if (!isHeldDown) return;
      decrement(cur);
      timeoutId2 = setTimeout(loop, 200);
    })();
  }).on('mouseup mouseleave', function () {
    isHeldDown = false
  });

  var disabledDays = [
    '1.1.2019',
    '16.2.2019',
    '11.3.2019',
    '21.4.2019',
    '22.4.2019',
    '1.5.2019',
    '24.6.2019',
    '6.7.2019',
    '15.8.2019',
    '1.11.2019',
    '24.12.2019',
    '25.12.2019',
    '26.12.2019',

    '1.1.2020',
    '16.2.2020',
    '11.3.2020',
    '12.4.2020',
    '13.4.2020',
    '1.5.2020',
    '24.6.2020',
    '6.7.2020',
    '15.8.2020',
    '1.11.2020',
    '24.12.2020',
    '25.12.2020',
    '26.12.2020',

    '1.1.2021',
    '16.2.2021',
    '11.3.2021',
    '4.4.2021',
    '5.4.2021',
    '1.5.2021',
    '24.6.2021',
    '6.7.2021',
    '15.8.2021',
    '1.11.2021',
    '24.12.2021',
    '25.12.2021',
    '26.12.2021',
  ];

  function noSundaysOrHolidays(date) {
    var day = date.getDay();
    if (day != 0 && day != 1) {
      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      for (i = 0; i < disabledDays.length; i++) {
        if($.inArray((d) + '.' + (m+1) + '.' + y, disabledDays) != -1) {
          // console.log('bad:  ' + d + '.' + (m+1) + '.' + y + ' / ' + disabledDays[i]);
          return [false];
        }
      }
      return [true];
    } else {
      if (day == 0) {
        return [day != 0, ''];
      }
      if (day == 1) {
        return [day != 1, ''];
      }
    }
  }

  $(".datepicker").datepicker({
    dateFormat: "yy / mm / dd",
    showOtherMonths: true,
    selectOtherMonths: true,
    minDate: 1,
    beforeShowDay: noSundaysOrHolidays,
    beforeShow: function(event, ui) {
      if (!$("#datestyle").length) {
        $("body").append("<style id='datestyle'></style>");
      }
      $("#datestyle").html('.ui-datepicker{width:'+$("input.datepicker").outerWidth()+'px !important}');
      setTimeout(function() {
        $("#datestyle").html('.ui-datepicker{width:'+$("input.datepicker").outerWidth()+'px !important}');
      }, 0);
    },
  });
  $("select").crfs();
  $("form").validate();

  $(document).on('mousedown', ".qnt-select .btn-minus", function () {
    isHeldDown = true;
    var cur = $(this);

    clearTimeout(timeoutId);
    clearTimeout(timeoutId2);
    (function loopa () {
      if (!isHeldDown) return;
      increment(cur);
      timeoutId = setTimeout(loopa, 200);
    })();
  }).on('mouseup mouseleave', function () {
    isHeldDown = false
  })
  $(document).on('click2 touchend', ".qnt-select .btn-plus", function () {
    var input = $(this).parent().find("input");
    var val = parseInt(input.val())+1;
    input.val(val).change();
    return false;
  });
  $(document).on('click2 touchend', ".qnt-select .btn-minus", function () {
    var input = $(this).parent().find("input");
    if (input.val() != 2) {
      var val = parseInt(input.val())-1;
      if (val < 2) { val = 2; };
      input.val(val).change();
    }
    return false;
  });
  $(document).on('click', ".qnt-select .btn-plus", function () {
    return false;
  });
  $(document).on('click', ".qnt-select .btn-minus", function () {
    return false;
  });
  $(document).on('click', ".selected-list .delete", function () {
    $('html, body').stop().animate({
      scrollTop: $(".register-form").offset().top
    }, 600, function() {
      $(".second-step").removeClass("active");
    });
    return false;
  });


  function glleryCheckPag() {
    lazyload($('.inside-gallery .slick-active img[data-src]'));
    $(".slick-arrow").addClass("active-click");
    if ($(".tabs-h .current").prev().length) {
      $(".slick-prev").addClass("active").find(".years").text($(".tabs-h .current").prev().find("a").text());
    } else {
      $(".slick-prev").removeClass("active");
    }
    if ($(".tabs-h .current").next().length) {
      $(".slick-next").addClass("active").find(".years").text($(".tabs-h .current").next().find("a").text());
    } else {
      $(".slick-next").removeClass("active");
    }
  }
  function glleryInit() {

    $(".inside-gallery.slick-initialized").slick('unslick');
    $(".inside-gallery").slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: 3,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#arrows"></use></svg><span class="label">Atgal</span><span class="years"></span></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#arrows"></use></svg><span class="label">Toliau</span><span class="years"></span></button>',
    }).on('beforeChange', function(){
      $(".slick-arrow").removeClass("active-click");
      animItems();
    }).on('afterChange', function(){
      glleryCheckPag();
    });
    glleryCheckPag();

  }

  function productInit() {

    $(".pro-gallery .slides.slick-initialized").slick('unslick');
    $(".pro-gallery .slides").slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: 3,
      adaptiveHeight: false,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#arrows"></use></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#arrows"></use></svg></button>',
    }).on('beforeChange', function(){
      animItems()
    }).on('afterChange', function(cur, cr, nextSlide){
      $(".tab-c.active .product-details").removeClass("active").eq(nextSlide).addClass("active");
      lazyload($('.pro-gallery .slides:visible .slick-active img'));
    });
    lazyload($('.pro-gallery .slides:visible .slick-active img'));
  }
  productInit();

  $(document).on('click', ".gallery-row .slick-prev.active-click.slick-disabled", function () {
    $(".tabs-h .current").prev().find("a").click();
    return false;
  });

  $(document).on('click', ".gallery .image-holder", function () {
    $(".gallery-holder").css({ minHeight: $(".gallery-row").height() });
    $("body").addClass("modal-gallery");
    loadbig = true;
    glleryInit();
    setTimeout(function() {
      lazyload($('.inside-gallery:visible .slick-active img'));
    }, 0);
    var inter = parseInt($(this).attr("href").replace("#", ""));
    $( '.inside-gallery' ).slick('slickGoTo', inter-1 );
    return false;
  });

  $(document).on('click', ".gallery-holder .close", function () {
    $("body").removeClass("modal-gallery");
    loadbig = false;
    glleryInit();
    lazyload($('.inside-gallery:visible .slick-active img'));
    return false;
  });

  $(document).on('click', ".gallery-row .slick-next.active-click.slick-disabled", function () {
    $(".tabs-h .current").next().find("a").click();
    return false;
  });

  $(document).on('click', ".years a", function () {
    $(".gallery").removeClass("active");
    $($(this).attr("href")).addClass("active");
    $(".gallery-row").addClass("active");
    $(".years li").removeClass("current");
    $(this).parent().addClass("current");
    $('html, body').stop().animate({
      scrollTop: $(".tabs-h").offset().top
    }, 600);
    setTimeout(function() {
      glleryInit();
      lazyload($('.inside-gallery:visible .slick-active img'));
    }, 0);
    $('.years .container').stop().animate({
      scrollLeft: $(".years li.current").index() * ($(window).width()/2) - $(window).width()/4
    }, 600);
    return false;
  });

  $(document).on('click', ".product-tabs a", function () {
    $(".tab-c").removeClass("active");
    $($(this).attr("href")).addClass("active");
    $("body").toggleClass("tab-active");
    $(".product-tabs li").removeClass("current");
    $(this).parent().addClass("current");
    productInit();
    if ($(window).width() < 1023) {
      $('html, body').stop().animate({
        scrollTop: 0
      }, 600);
    }
    return false;
  });

  $(document).on('click', ".cookie-bar .btn.accept", function () {
    setCookie("policy", true, 365);
    setCookie("policy-accepted", true, 365);
    $(".cookie-bar").slideUp(300);

    dataLayer.push({'event': 'cookie_consent_given_functional'});
    dataLayer.push({'event': 'cookie_consent_given_statistical'});
    dataLayer.push({'event': 'cookie_consent_given_marketing'});

    return false;
  });

  $(document).on('click', ".cookie-bar .btn.decline", function () {
    setCookie("policy", true, 365);
    setCookie("policy-accepted", false, 365);
    $(".cookie-bar").slideUp(300);

    dataLayer.push({'event': 'cookie_consent_given_functional'});

    return false;
  });

  if (!getCookie("policy")) {
    $(".cookie-bar").addClass("active");
  } else {
    if (getCookie("policy-accepted") == 'true') {
      dataLayer.push({'event': 'cookie_consent_given_functional'});
      dataLayer.push({'event': 'cookie_consent_given_statistical'});
      dataLayer.push({'event': 'cookie_consent_given_marketing'});
    } else {
      dataLayer.push({'event': 'cookie_consent_given_functional'});
    }
  }

  var loadbig = false;

  function lazyload(img) {
    img.each(function(){
      $(this).filter('[data-style]').attr('style', $(this).attr('data-style')).removeAttr('data-style');
      if (loadbig) {
        $(this).filter('[databig-src]').attr('src', $(this).attr('databig-src')).removeAttr('data-src');
        $(this).filter('[databig-srcset]').attr('srcset', $(this).attr('databig-srcset')).removeAttr('data-srcset');
      } else {

        $(this).filter('[data-src]').attr('src', $(this).attr('data-src')).removeAttr('data-src');
        $(this).filter('[data-srcset]').attr('srcset', $(this).attr('data-srcset')).removeAttr('data-srcset');
      }
    })
  }
  lazyload($('.bg'));
  $(window).on('resize', function() {
    lazyload($('.bg'));
  });

  function scrollCheck() {
    if ($(".pro-top-bg:visible").length) {
      $(".pro-top-bg").css({ transform: 'translate3d(0px, '+-$(window).scrollTop()/$(window).height()*5+'%, 0px)' });
    }
    if ($(".tabs-h").length) {
      if ($(window).scrollTop() > $(".tabs-h").offset().top) {
        $(".tabs-h").addClass("moved");
      } else {
        $(".tabs-h").removeClass("moved");
      }
    }
  }

  $('.tabs-h:not(.dis)').onePageNav({
    filter: ':not(.dis)'
  });

  $(".gallery-list").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#arrows"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#arrows"></use></svg></button>',
  }).on('beforeChange', function(){
    animItems()
  });

  function resizeCheck() {
    var winWidth = $(window).width();
    if (winWidth<768) {
      if (!$("body").hasClass("mobile-v")) {
        $(".options-list").slick({
          dots: true,
          arrows: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
        }).on('beforeChange', function(){
          animItems()
        });
        $("body").addClass("mobile-v");
      };
    } else {
      if ($("body").hasClass("mobile-v")) {
        $(".options-list.slick-initialized").slick('unslick');
        $("body").removeClass("mobile-v");
      };
    }
  }
  resizeCheck()
  scrollCheck()
  $(window).on('scroll', function() {
    scrollCheck()
    animItems()
  });
  $(window).on('resize', function() {
    animItems()
    scrollCheck()
    resizeCheck()
  });

});



// WEBPACK FOOTER //
// ./scripts/main.js